import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'components/cosmos';
import { Modal } from 'components/cosmos/v2/modal';
import { useTranslation } from 'configs/translationContext';
import { inject } from 'mobx-react';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

const DeleteModal = ({
  isOpen,
  title,
  description,
  onCancel,
  isMobile = false,
  onConfirm,
  cancelLabel = 'general.cancel',
  confirmLabel = 'general.exclude'
}) => {
  const { t } = useTranslation();
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm?.();
    } catch {
      UiService.setAlertError('error_try_again');
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal show={isOpen} onClose={onCancel}>
      <Modal.Header>
        <h3 className="_text-3 _text-lg-4 _font-weight-light _m-0">{title}</h3>
      </Modal.Header>
      <Modal.Body>
        <p className="_text-left _text-gray-600">{description}</p>
      </Modal.Body>
      <Modal.Footer className="_flex-column-reverse _flex-lg-row _justify-content-lg-end">
        <Button
          variation="default"
          className="_mt-4 _mt-lg-0 _mr-lg-3"
          onClick={onCancel}
          size={isMobile ? 'block' : 'md'}
        >
          {t(cancelLabel)}
        </Button>
        <Button
          variation="danger"
          loading={isDeleting}
          onClick={handleConfirm}
          size={isMobile ? 'block' : 'md'}
        >
          <FontAwesomeIcon icon={['fal', 'trash']} className="_mr-3" />
          {t(confirmLabel)}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string
};

export default inject((store) => ({
  isMobile: store.UiStore.isMobile
}))(DeleteModal);
